import axios from 'axios';
import Vue from 'vue'

export default {

    findItems (filter, supplierId, page, pageSize,groupId) {
        return axios.get('/api/items/list', { params: { filter: filter,supplierId: supplierId, page: page, pageSize: pageSize,groupId:groupId} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    findNewItems () {
        return axios.get('/api/items/new-items')
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    findNowAvailableItems () {
        return axios.get('/api/items/now-available')
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    findPromotionItems (filter, supplierId, page, pageSize, selectedPromotionId,category,groupId) {
        return axios.get('/api/items/promotion/list', { params: { filter: filter,supplierId: supplierId, page: page, pageSize: pageSize , selectedPromotionId:selectedPromotionId, category:category,groupId:groupId} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getCategories (level, customerId, parentId, page, pageSize) {
        return axios.get('/api/items/categories', { params: { level: level, customerId: customerId, parentId: parentId, page: page, pageSize: pageSize } })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getItem (itemId, customerId) {
        return axios.get('/api/items/details', { params: { itemId: itemId, customerId: customerId } })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getSupplierItems (supplierId) {
        return axios.get('/api/items/list',{params: {supplierId: supplierId}})
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    }, 
    findItemsSupplier (filter, page, pageSize) {
        return axios.get('/api/items/supplier/list', { params: { filter: filter, page: page, pageSize: pageSize } })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    removeItem (itemId) {
        return axios.post('/api/items/remove', {id : itemId})
        .then(response => {
            if (response && response.data) {
                Vue.prototype.$snotify.success("Article supprimé avec succès");
                return response.data;
            }
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    saveItem(item){
        return axios.post('/api/items/save', item)
        .then(response => {
            
            if (response && response.data) {
                Vue.prototype.$snotify.success("Article enregistré avec succès");
                return response.data;
            } 
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})

    },
    uploadImage(formData,id){
        return axios.post("/api/image/upload/"+id, formData, {headers: {'Content-Type': 'multipart/form-data' }})
        .then(response => {
            
            if (response && response.data) {
                Vue.prototype.$snotify.success("Image modifiée avec succès");
                return response.data;
            }
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    deleteImage(itemId){
        return axios.post("/api/image/remove/"+itemId)
        .then(response => { 
            if (response && response.data) {
                Vue.prototype.$snotify.success("Image supprimée avec succès");
                return response.data;
            }
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    uploadCSV(formData){
        return axios.post("/api/items/file/", formData, {headers: {'Content-Type': 'multipart/form-data' }})
        .then(response => {
            if (response && response.data) {
                Vue.prototype.$snotify.success('Articles importés avec succès', 'Import CSV');
                return response.data;
            }
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },


    getMaxFileSize() {
        return axios.get('/api/items/size')
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    addNewBrand(newBrandName){
        var newBrand = {name: newBrandName};
        return axios.post('/api/items/brand/new', newBrand)
        .then(response => {
            if (response && response.data) {
                Vue.prototype.$snotify.success("Marque ajoutée avec succès");
                return response.data;
            } 
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})

    },

    addNewGroup(newGroupName){
        var newGroup = {name: newGroupName};
        return axios.post('/api/items/itemGroup/new', newGroup)
        .then(response => {
            if (response && response.data) {
                Vue.prototype.$snotify.success("Groupe ajoutée avec succès");
                return response.data;
            } 
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})

    },

    getAllBrands(){
        return axios.get('/api/items/brand/all')
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getAllGroups(supplierId, promotionId){
        return axios.get('/api/items/group/all',{params: {supplierId: supplierId, promotionId:promotionId}})
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },


    changeBrandName(brand, newName){
        return axios.post('/api/items/brand/edit',{brand: brand, newName:newName})
        .then(response => {
            if (response && response.data) {
                Vue.prototype.$snotify.success("Marque modifiée avec succès");
                return response.data
            } 
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    changeGroupName(itemGroup,newName){
        return axios.post('/api/items/group/edit',{itemGroup: itemGroup, newName:newName})
        .then(response => {
            if (response && response.data) {
                Vue.prototype.$snotify.success("Groupe modifié avec succès");
                return response.data
            } 
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    deleteBrand(brand){
        return axios.post("/api/items/brand/remove/", brand)
        .then(response => {
            if (response && response.data) {
                Vue.prototype.$snotify.success("Marque supprimée avec succès");
                return response.data;
            } 
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    deleteGroup(itemGroup){
        return axios.post("/api/items/group/remove/", itemGroup)
        .then(response => {
            if (response && response.data) {
                Vue.prototype.$snotify.success("Groupe supprimé avec succès");
                return response.data;
            } 
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    groupModification(selectedBrand,selectedBrandDiscount,selectedBrandGratuity){
        return axios.post("/api/items/brand/group/modification", {brand: selectedBrand, discount: selectedBrandDiscount, gratuity: selectedBrandGratuity})
        .then(response => {
            
            if (response && response.data) {
                Vue.prototype.$snotify.success("Modification groupée est terminée avec succès");
                return response.data;
            }
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    groupModificationForGroup(selectedGroup,selectedGroupDiscount,selectedGroupGratuity){
        return axios.post("/api/items/group/groupModification", {itemGroup: selectedGroup, discount: selectedGroupDiscount, gratuity: selectedGroupGratuity})
        .then(response => {
            
            if (response && response.data) {
                Vue.prototype.$snotify.success("Modification groupée est terminée avec succès");
                return response.data;
            }
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    findAllItems (filter,  page, pageSize) {
        return axios.get('/api/items/search/catalog/list', { params: { filter: filter, page: page, pageSize: pageSize} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    findAllPromotionItems (filter,  page, pageSize) {
        return axios.get('/api/items/search/promotion/list', { params: { filter: filter, page: page, pageSize: pageSize} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    exportPDF(id,isPromotion){
        axios({
            url:'/api/items/get/'+id+'/'+isPromotion,
            method: 'GET',
            responseType: 'blob', // important
          }).then((response) => {

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Catalogue.pdf');
            document.body.appendChild(link);
            link.click();
          });
    },

    findAll (filter,  page, pageSize, supplierId) {
        return axios.get('/api/items/admin/items/list', { params: { filter: filter, page: page, pageSize: pageSize,supplierId:supplierId} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

}

